import { Component, OnInit,ViewChild, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {SubmitdataService} from "src/app/services/submitdata/submitdata.service";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { ApprovalinfoComponent } from 'src/app/common/ngbmodel/approvalinfo/approvalinfo.component';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { isNullOrUndefined } from 'util';
import { post } from 'selenium-webdriver/http';
@Component({
  selector: 'app-manual-intervention',
  templateUrl: './manual-intervention.component.html',
  styleUrls: ['./manual-intervention.component.css']
})
export class ManualInterventionComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport, {})
  public viewPort: CdkVirtualScrollViewport;
  showdistcolumn : boolean
  distuuid = "null";
  datasubmit = 'statewise';
  showdistdropdown : boolean;
  districtflag : boolean;
  tableData  = [];
  DistrictList = [];
  selectedistrict:any;
  stateDropDownList = [];
  stateuuid = null;
  isverified = null;
  reportsdata;
  checkall;
  urlparams;
  modalRef : any;
  activeSpinner : boolean;
  userdetails = {};
  monthlist : object = {'montharray' :''};
  yearDropDownList;
  assessmentYear;
  activesidetab;
  validation: boolean[] = new Array(1).fill(true);
  TableHeader : any;
  activespineer : Boolean;
  formInputfilter: object = { 'lu': "" }

  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  monthsList: any;
  selectedMonth: any;
  computedData: any = [];
  stateArrayList: any[];
  selectedstate:any;
  statelists: any[];
  filterdistrict: any;
  showdistdrop: boolean;
  selectedId: any;
  constructor(private submitdataservice : SubmitdataService,
    public tableconstants : TableConstantsModule,
    private constants : ConstantsModule,
    private logsrv : AuthloginService,
    private toastr : ToastrService,
    private utils : UtilsModule,
    private route: ActivatedRoute,
    private modalService: NgbModal
    ) { }

  ngOnInit() {
    this.yearDropDownList = this.submitdataservice.getassesmentYear();
    this.assessmentYear = this.yearDropDownList[this.yearDropDownList.length-1];
    this.userdetails = this.logsrv.checkloginstatus();
    this.navtabclick('approval');
    this.getstateslist();
    this.formInputfilter['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];

    this.monthsList = this.monthList;
    if(this.activesidetab == 'approval'){
      this.getassesmentunit();
    }
    this.setCurrentMonthDefault();
  }
  public navtabclick(type){
    if(type == this.activesidetab)
     return
    this.activesidetab = type;
    this.getReports();
  }
  async getassesmentunit(){
    // this.activespineer = true;
   let options = {
     "st" : (this.stateuuid != 'null' ? this.stateuuid : null),
     "userId" : this.userdetails['loggedUserData']['userProfile']['userId']
   }
  this.showdistdropdown = await this.submitdataservice.getAssesmentData(options);
  if(this.showdistdropdown == false){
    this.districtflag = false
  }
  this.activeSpinner = false;
  if(this.showdistdropdown){
    this.getLocationForDistrict();
  }
}
selectOption(month){
  this.selectedMonth = month
}
setCurrentMonthDefault(){
  let currentmonth = new Date().getMonth()
  let currentmonthObj;
  this.monthsList.forEach(monthObj =>{
    if(parseInt(monthObj['key'])  == currentmonth + 1){
      currentmonthObj = monthObj;
    }
  });
  this.monthlist['montharray'] = currentmonthObj['key'];
}
getstateslist(){
  let postdata = {};
  this.stateArrayList = [];
  this.statelists = [];
  postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
  postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
  postdata["component"] = "";
  postdata["src"] = "";
  this.submitdataservice.getLocationList(postdata).subscribe(data =>{
    if(data){
       this.statelists = [];
         Object.keys(data).forEach(key =>{
        data[key].forEach(statelist => {
          this.stateArrayList.push(statelist);
          this.stateArrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
          // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

        });
      })
    }
  })

}
showdistrictdropdown(stateuuid){
  this.filterdistrict = stateuuid;
  if(stateuuid){
    this.showdistdrop = true;
  } else{
    this.showdistdrop = false;
  }
  if(this.showdistdrop){
    this.getLocationForDistrict();
  }
}
getLocationForDistrict(){
  this.DistrictList = []
  this.distuuid = "null"
  let option = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    'puuid': this.filterdistrict
  };
  this.activespineer = true;
  this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
    this.activespineer = false;
    if(Array.isArray(data)){
      this.DistrictList = data;
      this.DistrictList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    }
    // else
    //  this.fieldDropDownList['DistrictList'] = [];
   
},function(err){
    this.activespineer = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  })
}
typechanged(){
  if(this.datasubmit == 'statewise'){
   this.districtflag = false;
  } else  {
    this.districtflag = true;
  }
  console.log("cjdbcjdncjsdc",this.stateuuid);
  console.log("cjdbcjdncjsdcdist",this.distuuid)
}
  getLocationList(){
    let option = {};
    this.stateDropDownList = [];
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    // option['puuid'] = this.constants['COUNTRYUUID']
    // option['type'] = type;
    option["component"] = "";
    option["src"] = "";
    this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data =>{
      if(data){
        // var data = this.submitdataService.getLocationList();
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            this.stateDropDownList.push(list);
          });
        });
        // this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
      }
      else
       this.stateDropDownList = [];
      this.activeSpinner = false;
      this.preparedataforweights()
  },function(err){
      this.activeSpinner = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    });
}
  getReports(){
    // if(this.basicValidation()){
    this.checkall = false;
    let postdata = {};
    this.activeSpinner = true;
    postdata = this.getbasicparams();
    this.tableData = [];
    this.submitdataservice.getValidateReports(postdata).subscribe(data =>{
      this.reportsdata = data['data'];
      if(Object.keys(this.reportsdata).length > 0){
        this.preparedataforcomputedData();
      } else {
        this.tableData = [];
      }
      this.activeSpinner = false;
    });
  }

  preparedataforweights(){
    this.tableData = [];
      if(!isNullOrUndefined(this.reportsdata)){
      Object.keys(this.reportsdata).forEach(type=>{
        if(type != 'approved'){
          Object.keys(this.reportsdata[type]).forEach(stateuuid=>{
            let obj = {};
            obj['statename'] = this.getstatename(stateuuid);
            obj['id'] = stateuuid;
            obj['indicatordata'] = this.reportsdata[type][stateuuid];
            this.tableData.push(obj);
          });
        }
      })
    }
    // }
    
  }
  getstatename(id){
    let statename;
    this.stateDropDownList.forEach(statelist=>{
      if(statelist['uuid'] == id){
        statename = statelist['name'];
      }
    })
    return statename
  }
  preparedataforhtml(){
    Object.keys(this.reportsdata).forEach(type =>{
      Object.keys(this.reportsdata[type]).forEach(stateuuid=>{
        if(this.reportsdata[type][stateuuid]['score']){
          this.reportsdata[type][stateuuid]['score'] = this.reportsdata[type][stateuuid]['score'].toFixed(2);
        }
        this.tableData.push(this.reportsdata[type][stateuuid]);
      });
    });
  }
  preparedataforcomputedData(){
    Object.keys(this.reportsdata).forEach(type =>{
      Object.keys(this.reportsdata[type]).forEach(stateuuid=>{
        if(this.reportsdata[type][stateuuid]['score']){
          this.reportsdata[type][stateuuid]['score'] = this.reportsdata[type][stateuuid]['score'].toFixed(2);
        }
        this.computedData.push(this.reportsdata[type][stateuuid]);
      });
    });
  }
  infoClick(tableobj, type, name,verified,level){ 
    this.modalRef = this.modalService.open(ApprovalinfoComponent,{ backdrop: 'static',windowClass: 'backgroundTransparent  approvalinfo'})

    this.modalRef.componentInstance.weightdata = tableobj;
    this.modalRef.componentInstance.ay = this.assessmentYear;
    this.modalRef.componentInstance.subtimeperiod = this.selectedMonth
    this.modalRef.componentInstance.period = 'annual';
    this.modalRef.componentInstance.computatedType = 'normal';
    this.modalRef.componentInstance.stateuuid = type;
    this.modalRef.componentInstance.distuuid = type;
    this.modalRef.componentInstance.statename = name;
    this.modalRef.componentInstance.isverified = verified;
    this.modalRef.componentInstance.stateDistrict = level
    this.modalRef.componentInstance.type = this.activesidetab == "approval" ? "admin-approval" : "admin-weightage"
    this.modalRef.result.then((result) => {
      if(result == 'load')
        this.getReports();
    }, (reason) => {
  
    });
 
  }
  getLevel(datasubmit){
    if(datasubmit == 'statewise'){
      return 'STATE';
    } else if(datasubmit == 'districtwise' ){
      return 'DISTRICT';
    }

  }
   getdistuuid(selectedistrict){
     this.selectedId = selectedistrict;
   }

  getbasicparams(){
    let postdata = {};
    postdata['pu'] = null;
    postdata['ay'] = this.assessmentYear;
    postdata['subTp'] = this.monthlist['montharray'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = this.constants.COMPONENT['COMPUTED_DATA'];
    postdata["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['userType'] = this.userdetails['roles'][0];
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata["lu"] = this.selectedId;
    return postdata;
  }
  formatpostData(){
    let postdata = {};
    postdata['ay'] = this.assessmentYear;
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['subTp'] = this.monthlist['montharray'];
    postdata['component'] = this.constants.COMPONENT['COMPUTED_DATA'];
    postdata["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['userType'] = this.userdetails['roles'][0];
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata["lu"] = this.selectedId;
    return postdata;

  }
  getLuUUID(stateuuid, distuuid){
    if(!this.districtflag){
      return stateuuid;
    } else{
      return (distuuid == "null" ? (stateuuid == "null" ? null : stateuuid) : distuuid)
    }
    }
  
  checkvalue(val){
    if(!val || val == "null")
     return "-";
    return val;
  }
  approveOrrejectclick(action){
    let entityList = this.formatdataforbackend();
    if(entityList.length > 0){
      this.activeSpinner = true;
      let postdata = {};
      postdata = this.getbasicparams();
      postdata['action'] = this.constants.ACTION[action];
      postdata['entityList'] = JSON.stringify(entityList);
      let actionmsg = this.constants.ACTIONMSG[action];
      let erroractionmsg = this.constants.ERRORACTIONMSG[action];
      let filetype = this.constants.FILETYPE['report'];
      this.submitdataservice.approveorreject(postdata).subscribe(data =>{
        if(data['status']){
          if(action=='approve')
            this.toastr.success(actionmsg +' '+(entityList.length+1)+ ' records successfully');
          else 
            this.toastr.success(filetype + ' ' + actionmsg);
          this.getReports();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while "+erroractionmsg +" record's")
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.error('Please select atleast one record')
    }
  }
  formatdataforbackend(){  
    let array = [];
    this.tableData.forEach(element=>{
        if(element.ischecked){
          array.push(element['id']);
        }
    })
    return array;
  }
  checkallset(checkall){
    this.computedData.forEach(element=>{
        element['ischecked'] = checkall ? true : false;
    });
  }
 
  submitvalue(list){
    this.activeSpinner = true;
    if(list['value']){
      let postdata = {};
      postdata = this.getbasicparams();
      postdata['action'] = this.constants.ACTION['modify'];
      postdata['data'] = JSON.stringify({[this.assessmentYear]:[{"id":list['entityUUID'],"value":list['value']}]});
      this.submitdataservice.modifyData(postdata).subscribe(data =>{
        if(data['status']){
          this.toastr.success('Updated Successfully');
          // this.getReports();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while updating value")
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.warning('Value filed should not be empty')
    }
   
  }
  checkscorevalue(val){ 
    return val == 0 ? 0 : (val !=0 && val ? (val) : '')
  }
  public basicValidation():boolean{
    this.validation[0] = this.utils.checkfield(this.stateuuid)
    if(this.datasubmit == 'districtwise')
     this.validation[1] = this.utils.checkfield(this.distuuid)
    else  
      this.validation[1] = true;
    return this.validation[0] && this.validation[1];
  }
  approveorrejectData(action){
    let entitydata = this.formatentityListdata();
    if(entitydata.length > 0){
      this.activeSpinner = true;
      let postdata = {};
      postdata = this.formatpostData();
      postdata['entityList'] = JSON.stringify(entitydata);
      postdata['action'] = this.constants.ACTION[action];
      let actionmsg = this.constants.ACTIONMSG[action];
      let erroractionmsg = this.constants.ERRORACTIONMSG[action];
      let filetype = this.constants.FILETYPE['report'];
      this.submitdataservice.approveorreject(postdata).subscribe(data =>{
        if(data['status']){
          if(action=='approve')
            this.toastr.success(actionmsg +' '+(entitydata.length+1)+ ' records successfully');
          else 
            this.toastr.success(filetype + ' ' + actionmsg);
          this.getReports();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while "+erroractionmsg +" record's")
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.error('Please select atleast one record')
    }
  }
  formatentityListdata(){
    let entitylist = [];
  this.computedData.forEach(list => {
    if(list.ischecked){
      entitylist.push(list['id']);
    }
  });
  return entitylist;
  }
}
